import React from 'react';
import { ImpactTypeChart } from './ImpactTypeChart.jsx';
import { ImpactScaleChart } from './ImpactScaleChart.jsx';
import { ImpactPerceptionChart } from './ImpactPerceptionChart.jsx';
import { useWindowSize } from '../../../../lib/utils.js';
import SubHeader from '../../../SubHeader.jsx';

const RADIAN = Math.PI / 180;

const textProps = {
  fill: 'var(--color--dark-blue-grey)',
  fontFamily: 'Varela Round',
  textAnchor: 'middle',
};

const formatPercent = (percent) => `${Math.round(percent * 100)}%`;

const RenderLabel = ({
  cx,
  cy,
  fill,
  name,
  archived,
  midAngle,
  outerRadius,
  percent,
}) => {
  if (percent < 0.02) {
    return null;
  }

  const size = useWindowSize();

  const sin = Math.sin(-midAngle * RADIAN);
  const cos = Math.cos(-midAngle * RADIAN);
  const offsetRadius =
    22 + Math.abs(sin) * (1 - Math.abs(cos)) * (0.04 / percent) * 40;
  const sx = cx + (outerRadius + 4) * cos;
  const sy = cy + (outerRadius + 4) * sin;
  const mx = cx + (outerRadius + offsetRadius) * cos;
  const my = cy + (outerRadius + offsetRadius) * sin;
  const ex = cx + (50 + outerRadius) * (cos >= 0 ? 1 : -1);
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        fill="none"
        stroke={fill}
      />
      <circle cx={ex} cy={ey} r={4} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 10}
        y={ey}
        fill={
          archived ? 'var(--color--blue-grey)' : 'var(--color--dark-blue-grey)'
        }
        textAnchor={textAnchor}
        dominantBaseline="central"
        fontSize={size.width > 1400 ? 14 : 12}
      >
        {name} &bull;
        {formatPercent(percent)}
      </text>
    </g>
  );
};

function ChangeImpactsOverview({
  results,
  changeImpactTypes,
  pieTypeRef,
  pieScaleRef,
  piePerceptionRef,
}) {
  return (
    <React.Fragment>
      <SubHeader flexJustify small>
        <div className="flex">
          <h2>Pie Charts</h2>
        </div>
      </SubHeader>
      <div
        className="component component-bg-white"
        style={{ padding: '26px 0' }}
      >
        <div className="flex flex-justify" style={{ marginBottom: '40px' }}>
          <div
            className="flex-col"
            style={{ maxWidth: '700px', width: '100%', margin: '0 auto' }}
          >
            <h2 className="text-center">Change Impact Type</h2>
            <ImpactTypeChart
              pieTypeRef={pieTypeRef}
              results={results}
              textProps={textProps}
              changeImpactTypes={changeImpactTypes}
              renderLabel={<RenderLabel />}
            />
          </div>

          <div
            className="flex-col"
            style={{ maxWidth: '700px', width: '100%', margin: '0 auto' }}
          >
            <h2 className="text-center">Change Impact Scale</h2>
            <ImpactScaleChart
              pieScaleRef={pieScaleRef}
              results={results}
              textProps={textProps}
              renderLabel={<RenderLabel />}
            />
          </div>
        </div>
        <div className="flex">
          <div
            className="flex-col"
            style={{ maxWidth: '700px', width: '100%', margin: '0 auto' }}
          >
            <h2 className="text-center">Change Impact Perception</h2>
            <ImpactPerceptionChart
              piePerceptionRef={piePerceptionRef}
              results={results}
              textProps={textProps}
              renderLabel={<RenderLabel />}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default ChangeImpactsOverview;
